import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CaliforniaCitiesFooter from './CaliforniaCitiesFooter';
import { useTranslation } from '../hooks/useTranslation';

const { FiShield, FiMail } = FiIcons;

function Footer() {
  const { t } = useTranslation();
  
  const handleGetQuote = () => {
    window.open('https://quote.burbankinsuranceservices.com/1b0DiB', '_blank');
  };

  return (
    <footer className="bg-gray-800 text-white">
      {/* California Cities SEO Section */}
      <CaliforniaCitiesFooter />
      
      {/* Main Footer */}
      <div className="py-12 border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <img
                src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
                alt="Burbank Insurance Services"
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-300 mb-4">
                {t('footer.protectingFamilies')}
              </p>
              <div className="flex items-center space-x-2 text-sm">
                <SafeIcon icon={FiShield} className="text-blue-400" />
                <span className="text-gray-300">{t('header.licenseNumber')}</span>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold text-lg mb-4">{t('footer.learnMore')}</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link
                    to="/term-vs-whole-life"
                    className="hover:text-white transition-colors"
                  >
                    {t('footer.termVsWhole')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/online-vs-agent"
                    className="hover:text-white transition-colors"
                  >
                    {t('footer.onlineVsAgent')}
                  </Link>
                </li>
                <li>{t('footer.lifeInsurance')}</li>
                <li>{t('footer.insuranceConsultation')}</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold text-lg mb-4">{t('footer.contactUs')}</h4>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="text-blue-400" />
                  <a
                    href="mailto:info@burbankinsuranceservices.com"
                    className="hover:text-white transition-colors"
                  >
                    info@burbankinsuranceservices.com
                  </a>
                </div>
                <p className="text-sm text-gray-400 mt-4">
                  {t('footer.servingCAOnly')}
                </p>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold text-lg mb-4">{t('footer.readyToStart')}</h4>
              <p className="text-gray-300 mb-4">{t('footer.getPersonalizedQuote')}</p>
              <button
                onClick={handleGetQuote}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 w-full"
              >
                {t('footer.getMyPriceNow')}
              </button>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Burbank Insurance Services. {t('footer.allRightsReserved')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;